<template>
  <div>
    <div v-for="(it, i) in shown" :key="it.name" class="rb-row">
      <div class="rb-name" :title="it.name">{{ it.name }}</div>
      <div class="rb-barline">
        <div class="rb-track">
          <div class="rb-bar" :style="barStyle(it, i)"></div>
        </div>
        <div class="rb-val">{{ valueLabel(it) }}</div>
      </div>
    </div>
    <button
      v-if="topN && items.length > topN"
      class="rb-toggle"
      @click="expanded = !expanded"
    >
      {{
        expanded
          ? `▲ ย่อกลับ (แสดง ${topN} อันดับแรก)`
          : `▼ แสดงทั้งหมด ${items.length} รายการ`
      }}
    </button>
    <details class="rb-details">
      <summary>ดูข้อมูลเป็นตาราง</summary>
      <table class="rb-table">
        <tr>
          <th>{{ nameHeader }}</th>
          <th>{{ unit }}</th>
        </tr>
        <tr v-for="it in items" :key="'t' + it.name">
          <td>{{ it.name }}</td>
          <td>{{ valueLabel(it) }}</td>
        </tr>
      </table>
    </details>
  </div>
</template>

<script>
import { numVal, fmtVal } from "@/utils/nhsoDashboardFormat";

export default {
  name: "RankedBarList",
  props: {
    // [{ name, value, label? }] pre-sorted descending. `label` overrides the
    // rendered value text (e.g. "45,130 (83%)") while `value` drives bar length.
    items: { type: Array, required: true },
    topN: { type: Number, default: 0 }, // 0 = show all
    unit: { type: String, default: "" },
    nameHeader: { type: String, default: "รายการ" },
    colors: { type: Array, default: null }, // per-row ordinal ramp
  },
  data() {
    return { expanded: false };
  },
  computed: {
    shown() {
      return !this.topN || this.expanded
        ? this.items
        : this.items.slice(0, this.topN);
    },
    maxVal() {
      return Math.max(1, ...this.items.map(it => numVal(it.value)));
    },
  },
  methods: {
    valueLabel(it) {
      return it.label != null ? it.label : fmtVal(it.value);
    },
    barStyle(it, i) {
      return {
        width: `${(numVal(it.value) / this.maxVal) * 100}%`,
        background: this.colors ? this.colors[i % this.colors.length] : "#2a78d6",
      };
    },
  },
};
</script>

<style scoped>
.rb-row {
  margin: 10px 0;
}
.rb-name {
  font-size: 12px;
  color: var(--nd-text2);
  line-height: 1.35;
  margin-bottom: 4px;
  word-break: break-word;
}
.rb-barline {
  display: grid;
  grid-template-columns: 1fr 72px;
  align-items: center;
  gap: 10px;
}
.rb-track {
  position: relative;
  height: 18px;
  background: var(--nd-surface2);
  border-radius: 5px;
}
.rb-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 18px;
  border-radius: 5px;
  transition: width 0.35s ease;
}
.rb-val {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--nd-text);
  font-variant-numeric: tabular-nums;
}
.rb-toggle {
  font-size: 12px;
  color: var(--nd-accent);
  background: none;
  border: 0;
  padding: 8px 0 0;
  cursor: pointer;
  font-weight: 600;
}
.rb-toggle:hover {
  text-decoration: underline;
}
.rb-details {
  margin-top: 12px;
}
.rb-details summary {
  font-size: 12px;
  color: var(--nd-muted);
  cursor: pointer;
}
.rb-table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12.5px;
  margin-top: 8px;
}
.rb-table th {
  text-align: left;
  color: var(--nd-text2);
  border-bottom: 1px solid var(--nd-grid);
  padding: 5px 8px 5px 0;
}
.rb-table td {
  border-bottom: 1px solid var(--nd-grid);
  padding: 5px 8px 5px 0;
  font-variant-numeric: tabular-nums;
}
</style>
